<template>
  <!-- edit modal -->
  <b-container v-if="editAttributesModal" fluid class="bg-white p-3">
    <b-row class="justify-content-between">
      <b-col cols="6" sm="6" md="3" lg="2" class="mb-3 mb-lg-0">
        <b-row>
          <b-col cols="12">
            <b-form-group>
              <b-form-checkbox v-model="updateModal.Breakfast" switch>
                Breakfast
              </b-form-checkbox>
            </b-form-group>
            <b-form-group>
              <b-form-checkbox v-model="updateModal.Lunch" switch>
                Lunch
              </b-form-checkbox>
            </b-form-group>
            <b-form-group>
              <b-form-checkbox v-model="updateModal.Dinner" switch>
                Dinner
              </b-form-checkbox>
            </b-form-group>
            <b-form-group>
              <b-form-checkbox v-model="updateModal.Brunch" switch>
                Brunch
              </b-form-checkbox>
            </b-form-group>
            <b-form-group>
              <b-form-checkbox v-model="updateModal.Snack" switch>
                Snack
              </b-form-checkbox>
            </b-form-group>
          </b-col>
        </b-row>
      </b-col>
      <b-col cols="6" sm="6" md="3" lg="2">
        <b-form-group>
              <b-form-checkbox v-model="updateModal.Delivery" switch>
                Delivery
              </b-form-checkbox>
            </b-form-group>
            <b-form-group>
              <b-form-checkbox v-model="updateModal.TakeOut" switch>
                Take Out
              </b-form-checkbox>
            </b-form-group>
            <b-form-group>
              <b-form-checkbox v-model="updateModal.Catering" switch>
                Catering
              </b-form-checkbox>
            </b-form-group>
            <b-form-group>
              <b-form-checkbox v-model="updateModal.Banquet" switch>
                Banquet
              </b-form-checkbox>
            </b-form-group>
      </b-col>
      <b-col cols="6" sm="6" md="3" lg="2" class="mb-3 mb-md-0">
        <b-form-group>
              <b-form-checkbox v-model="updateModal.TakeReservations" switch>
                Take Reservations
              </b-form-checkbox>
            </b-form-group>
            <b-form-group>
              <b-form-checkbox v-model="updateModal.HappyHours" switch>
                Happy Hours
              </b-form-checkbox>
            </b-form-group>
            <b-form-group>
              <b-form-checkbox v-model="updateModal.OutdoorSeating" switch>
                Outdoor Seating
              </b-form-checkbox>
            </b-form-group>
            <b-form-group>
              <b-form-checkbox v-model="updateModal.FreeParking" switch>
                Free Parking
              </b-form-checkbox>
            </b-form-group>
      </b-col>
      <b-col cols="6" sm="6" md="3" lg="2">
        <b-form-group>
              <b-form-checkbox v-model="updateModal.WiFi" switch>
                Free WiFi
              </b-form-checkbox>
            </b-form-group>
            <b-form-group>
              <b-form-checkbox v-model="updateModal.HasTV" switch>
                TV
              </b-form-checkbox>
            </b-form-group>
      </b-col>
      <b-col cols="6" sm="6" md="3" lg="2">
        <b-form-group>
              <b-form-checkbox v-model="updateModal.Alcohol" switch>
                Alcohol Served
              </b-form-checkbox>
            </b-form-group>
            
            <b-form-group>
              <b-form-checkbox @change="updateModal.BeerAndWineOnly =  false" v-model="updateModal.FullBar" switch>
                Full Bar
              </b-form-checkbox>
            </b-form-group>
            <b-form-group>
              <b-form-checkbox @change="updateModal.FullBar =  false" v-model="updateModal.BeerAndWineOnly" switch>
                Beer & Wine Only
              </b-form-checkbox>
            </b-form-group>
            <b-form-group>
              <b-form-checkbox v-model="updateModal.BYOB" switch>
                BYOB
              </b-form-checkbox>
            </b-form-group>
      </b-col>
    </b-row>
  <b-row>
    <b-col cols="12" >
      <b-row>
        <b-col cols="6" class="d-flex justify-content-start px-4 mb-4 mt-2">
          <label for="AttrComment" class="mr-2 mt-2 text-nowrap">Restaurant Attributes Comments</label>
          <b-form-input id="AttrComment" v-model="updateModal.AttrComment" placeholder="Enter Restaurant Attributes Comments" />
        </b-col>
        
      </b-row>
      <b-row>
        <b-col cols="6" >
          <b-btn variant="warning" block class="text-nowrap" @click="saveAttributes">
              Save
            </b-btn>
        </b-col>
        <b-col cols="6">
          <b-btn variant="" style="background-color: #788f9c; color: #fff;" block class="text-nowrap" @click="editAttributesModal = false">
            Cancel
          </b-btn>
           
        </b-col>
      </b-row>
    </b-col>
  </b-row>
  </b-container>
  <b-container v-else-if="!loading && !editAttributesModal && value" fluid class="bg-white p-3">
    <b-row class="justify-content-between">
      <b-col cols="6" sm="6" md="3" lg="2" class="mb-3 mb-lg-0">
        <b-list-group>
          <b-list-group-item
            v-for="(value, key) in value.mealOptions"
            :key="key"
            :class="value ? '' : 'linethrough-styling'"
          >-
            {{key}}
          </b-list-group-item
          >
        </b-list-group>
      </b-col>
      <b-col cols="6" sm="6" md="3" lg="2">
        <b-list-group>
          <b-list-group-item
            v-for="(value, key) in value.deliveryOption"
            :key="key"
            :class="value ? '' : 'linethrough-styling'"
          >-
            {{key}}
          </b-list-group-item
          >
        </b-list-group>
      </b-col>
      <b-col cols="6" sm="6" md="3" lg="2" class="mb-3 mb-md-0">
        <b-list-group>
          <b-list-group-item
            v-for="(value, key) in value.otherOption"
            :key="key"
            :class="value ? '' : 'linethrough-styling'"
          >-
            {{key}}
          </b-list-group-item
          >
        </b-list-group>
      </b-col>
      <b-col cols="6" sm="6" md="3" lg="2">
        <b-list-group>
          <b-list-group-item
            v-for="(value, key) in value.technology"
            :key="key"
            :class="value ? '' : 'linethrough-styling'"
          >-
            {{key}}
          </b-list-group-item
          >
        </b-list-group>
      </b-col>
      <b-col cols="6" sm="6" md="3" lg="2">
        <b-list-group>
          <b-list-group-item
            v-for="(value, key) in value.bar"
            :key="key"
            :class="value ? '' : 'linethrough-styling'"
          >-
            {{key}}
          </b-list-group-item
          >
        </b-list-group>
      </b-col>
    </b-row>
  <b-row>
    <b-col cols="12" >
      <b-row>
        <b-col cols="10" class="d-flex justify-content-start"></b-col>
          <b-col cols="2" class="d-flex justify-content-end ">
            <b-btn variant="link" block class="text-nowrap" @click="editAttributes">
              Edit Attributes
            </b-btn>
          </b-col>
        </b-row>
    </b-col>
  </b-row>
  </b-container>
  <b-container v-else fluid class="bg-white p-3" style="height: 20vh; display: flex; justify-content: center; align-items: center;">
    <b-spinner variant="primary" label="Loading"></b-spinner>
  </b-container>
</template>

<script>
  export default {
    name: "index",
    props: {
      value: {
        required: true,
        type: Object
      }
    },
    data() {
      return {
        editAttributesModal: false,
        loading: false,
        updateModal: false
      }
    },
    methods: {
      cancelAttributes() {
        this.editAttributesModal = false
      },
      saveAttributes() {
        this.$api.getRestaurant
        .UpdateServices(this.updateModal).then((res) => {
          if (res.success) {
            this.$emit('refresh')
          }
        }).catch((err) => {
          this.$toast.error('Error updating attributes')
        })
        this.editAttributesModal = false
      },
      editAttributes() {
        let model = {
          RestaurantID: this.$store.state.selectedRestaurantId,
        }
        this.loading = true
        this.$api.getRestaurant.GetRestaurantProfile(model).then((res) => {
          if (res.success) {
            this.updateModal = res.results
          }
          this.loading = false
          this.editAttributesModal = true
        }).catch((err) => {
          this.loading = false
          this.editAttributesModal = false
        })
      }
    }
  }
</script>

<style scoped lang="scss">
  .bg-color {
    background-color: #ffffff;
  }
  .linethrough-styling {
    text-decoration: line-through;
    color: rgb(175, 173, 173);
  }
  .list-group {
    min-height: 100px;
    // padding: 0px 54px;
  }
  .list-group-item {
    background-color: transparent;
    border: none !important;
    padding: 0.3rem 0.5rem;
  }
  .maxHeight {
    /*max-height: 175px;*/
  }

  .customGrid {
    // white-space: nowrap;
  }
  @media (max-width: 1300px) {
    // .list-group {
    //   min-height: 220px;
    //   padding: 0px 45px;
    // }
  }


</style>
